import React from "react";
import Explainer from "../ExplainerModal";

const SystemsManagementExplainer = () => {
  return (
    <Explainer
      title="⚙️ Systems Management Explainer"
      content={
        <>
          <p>
            The <strong>Systems Management</strong> section allows administrators to manage agri-food systems specific to their country. Since the default list may not be exhaustive, users have the flexibility to create, edit, and delete systems as needed.
          </p>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#137A08" }}>
            ✨ Key Features
          </h3>
          <ul>
            <li>➕ <strong>Create</strong> new agri-food systems to reflect local realities.</li>
            <li>✏️ <strong>Edit</strong> existing systems to update information or make refinements.</li>
            <li>🗑️ <strong>Delete</strong> systems that are no longer relevant.</li>
          </ul>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#137A08" }}>
            🌍 Why It Matters
          </h3>
          <p>
            This feature ensures that countries can maintain accurate and up-to-date records of their agri-food systems.
          </p>
        </>
      }
    />
  );
};

export default SystemsManagementExplainer;
